module.exports = __webpack_public_path__ + "img/5.fc1fd372.png";